import { Reveal } from "@/components/landing/Reveal";

export const Statement = () => {
  return (
    <section data-testid="statement" className="relative overflow-hidden py-32">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[420px] w-[720px] max-w-full -translate-x-1/2 -translate-y-1/2 glow-violet blur-3xl opacity-60" />

      <div className="mx-auto max-w-5xl px-6 text-center lg:px-8">
        <Reveal>
          <h2 className="font-mega text-4xl leading-[0.95] text-white sm:text-6xl lg:text-7xl">
            You&rsquo;re One Decision From{" "}
            <span className="text-gradient">Changing Your Life</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-8 max-w-2xl text-lg text-muted-foreground">
            Most people don&rsquo;t fail because they lack ambition. They fail because they
            don&rsquo;t have a clear plan &mdash; or someone to keep them moving forward.
            That&rsquo;s where b&rarr;come comes in.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground/80">
            Your personal AI coach creates your roadmap, breaks big dreams into daily
            actions, tracks your progress, adapts as life changes, and keeps you
            motivated until you reach your goals.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Statement;
